import {Injectable} from "@angular/core";
import {UtilityService} from "@irb/irb-common/services/utility.service";
import {
    IPortfolioResultResponse,
    IPortfolioResultPFSECRebal,
    IPortfolioResultACCRebal,
    IPortfolioResultSecurityEquivalent,
    IPortfolioResultSECRebal,
    IPortfolioResultModelHistory,
    IACLevel
} from "@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model";
import {PrUtilityService} from "@irb/irb-editors/editor-portfolio-result/services/pr-utility.service";
import { JasperSettings } from "@irb/irb-dialogs/dialog-pr-export-pdf/dialog-pr-export-pdf.component";
import {AppService} from "@irb/app.service";

@Injectable({
    providedIn: "root"
})
export class PrAllocationsService {

    private _group: string;
    private _showExcluded: boolean;
    private _showEquivalents: boolean;
    private _assetClassDetail1: boolean = true;
    private _assetClassDetail2: boolean = true;
    private _assetClassDetail3: boolean = true;
    private _assetClassDetail4: boolean = true;
    isCashEqvEnabled = false;

    constructor(private prutil: PrUtilityService, private util: UtilityService, private as: AppService) {
      this.isCashEqvEnabled = this.as.getItem("IRB_APP_CONFIG")?.isCashEqvEnabled || false;
    }

    public set group(s: string) {
        this._group = s;
    }

    public get group(): string {
        return this._group;
    }

    public set showExcluded(b: boolean) {
        this._showExcluded = b;
    }

    public get showExcluded(): boolean {
        return this._showExcluded;
    }

    public set showEquivalents(b: boolean) {
        this._showEquivalents = b;
    }

    public get showEquivalents(): boolean {
        return this._showEquivalents;
    }

    public set assetClassDetail1(b: boolean) {
        this._assetClassDetail1 = b;
    }

    public get assetClassDetail1(): boolean {
        return this._assetClassDetail1;
    }

    public set assetClassDetail2(b: boolean) {
        this._assetClassDetail2 = b;
    }

    public get assetClassDetail2(): boolean {
        return this._assetClassDetail2;
    }

    public set assetClassDetail3(b: boolean) {
        this._assetClassDetail3 = b;
    }

    public get assetClassDetail3(): boolean {
        return this._assetClassDetail3;
    }

    public set assetClassDetail4(b: boolean) {
        this._assetClassDetail4 = b;
    }

    public get assetClassDetail4(): boolean {
        return this._assetClassDetail4;
    }

    appendChildEquivalents(data: IPortfolioResultResponse) {
        const dataGroups: Array<IPortfolioResultPFSECRebal> = [];
        data.isAllocationExcludedPositionRecordsPresent = false;
        data.isAllocationGroupEquivalentsRecordsPresent = false;

        // filter out any existing child equivalents
        data.pfSecRebalDTOList = data.pfSecRebalDTOList.filter(item => !item.isEquivalentChild);

        data.pfSecRebalDTOList.forEach(item => {
            delete item.isEquivalent;
            delete item.isEquivalentParent;
            delete item.parentSecList;
            delete item.countParent;
        })

        //iterate allocations data
        data.pfSecRebalDTOList.forEach((item: IPortfolioResultPFSECRebal) => {

            //modify excluded positions
            const isExcludedPosition = item.secExclusionType === "OPTION" || item.secExclusionType === "SHORT" || item.secExclusionType === "EXCLUDED";

            if (isExcludedPosition) {
                /*item.secCurPercntVal = null;
                item.secRelVariance = null;
                item.secAbsVariance = null;
                item.secDolrVariance = null;*/

                data.isAllocationExcludedPositionRecordsPresent = true;
            }

            item.parentSecSymb = item.secSymb;
            item.portfolioMktValueAfterAdj = data.mktValAfterAdj;

            //modify secRelVariance when secModelTargetPercnt is 0
            if(item.secModelTargetPercnt === 0) {
                item.secRelVariance = ((item.secCurPercntVal > 0) ? 100 : 0); //79762
                item.secRelVarianceAfterAdj = ((item.secPercntValAfterAdj > 0) ? 100 : 0); //79762
            }

            //modify allocations that have equivalents
            if (item.childEqvList && item.childEqvList.length > 0) {
                item.isEquivalentParent = true;

                //iterate allocations data for the equivalents
                data.pfSecRebalDTOList.forEach((c: IPortfolioResultPFSECRebal) => {
                    if (item.secSymb !== c.secSymb) {
                        //get the equivalent data for the given secId
                        const s = item.childEqvList.find((x: IPortfolioResultSecurityEquivalent) => x.eqvSecId === c.secId);

                        if (s) {
                            c.isEquivalent = true;
                            c.countParent = typeof c.countParent !== "undefined" ? ++c.countParent : 1;

                            if (typeof c.parentSecList !== "undefined") {
                                c.parentSecList.push(item);
                            } else {
                                c.parentSecList = [item];
                            }
                        }
                    }
                });
            }
        });

        data.pfSecRebalDTOList.forEach((item: IPortfolioResultPFSECRebal) => {
            if (item.isEquivalent) {
                item.parentSecList.forEach((s: IPortfolioResultPFSECRebal) => {
                    const n = this.util.clone(item) as IPortfolioResultPFSECRebal;

                    s.childEqvList.forEach((c: IPortfolioResultSecurityEquivalent) => {
                        if (n.secId === c.eqvSecId) {
                            n.equivalentSellPerc = c.equivalentSellPerc;
                            n.equivalentBuyPerc = c.equivalentBuyPerc;
                            n.secModelTargetPercnt = 0;
                        }
                    });

                    this.calculateAllocationEquivalent(data, n);
                    n.isEquivalentChild = true;
                    n.parentSecId = s.secId;
                    n.parentSecSymb = s.secSymb;
                    dataGroups.push(n);
                });
            }
        });

        data.isAllocationGroupEquivalentsRecordsPresent = dataGroups.length > 0;
        data.pfSecRebalDTOList = data.pfSecRebalDTOList.concat(dataGroups);

        //iterate allocations data in order to populate aggregate inRange values, must be done after call to calculateAllocationEquivalent
        data.pfSecRebalDTOList.forEach((item: IPortfolioResultPFSECRebal) => {
            //modify allocations that have equivalents
            if (item.childEqvList?.length > 0) {
                const aggSecCurPercntVal = data.pfSecRebalDTOList
                    .filter((c: IPortfolioResultPFSECRebal) => (c.isEquivalentChild && (item.secSymb == c.parentSecSymb)) || c.secSymb == item.secSymb)
                    .reduce((acc: number, val: any) => acc + val.secCurPercntVal, 0);

                const aggSecPercntValAfterAdj = data.pfSecRebalDTOList
                    .filter((c: IPortfolioResultPFSECRebal) => (c.isEquivalentChild && (item.secSymb == c.parentSecSymb)) || c.secSymb == item.secSymb)
                    .reduce((acc: number, val: any) => acc + val.secPercntValAfterAdj, 0);
                                    
                const d: IPortfolioResultModelHistory = data.modelHistoryList.find((x: IPortfolioResultModelHistory) => x.securitySymbol === item.secSymb);

                if(d) {
                    item.isEquivalentParentWithinRangeBefore = (aggSecCurPercntVal <= d.maximumPercentage && aggSecCurPercntVal >= d.minimumPercentage);
                    item.isEquivalentParentWithinRangeAfter = (aggSecPercntValAfterAdj <= d.maximumPercentage && aggSecPercntValAfterAdj >= d.minimumPercentage);
                }
            }
        });
    }

    calculateAllocationEquivalent(data: IPortfolioResultResponse, item: IPortfolioResultPFSECRebal) {
        let secPercent: number;
        let txnType: string;
        let txnAmt: number;
        let txnAmtTotal = 0;

        data.secRebalDTOList.forEach((orderItem: IPortfolioResultSECRebal) => {
            if (orderItem.securityId === item.secId) {
                txnAmtTotal += orderItem.txnType === "BUY" ? orderItem.txnAmt : orderItem.txnAmt * -1;
            }
        });

        txnType = txnAmtTotal >= 0 ? "BUY" : "SELL";
        txnAmt = txnAmtTotal;

        if (txnType === "BUY") {
            secPercent = item.equivalentBuyPerc;
        } else if (txnType === "SELL ALL" || txnType === "SELL" || txnType === "NONE") {
            secPercent = item.equivalentSellPerc;
        }

        const secMktValChild = (item.secMktVal * item.equivalentSellPerc) / 100;
        const secCurPercntVal = (secMktValChild / data.mktValAfterAdj) * 100;
        const secAdjAmt = (txnAmt * secPercent) / 100;
        const secMktValAfterAdj = secMktValChild + secAdjAmt;
        const secPercntValAfterAdj = (secMktValAfterAdj / data.mktValAfterAdj) * 100;
        const secAbsVariance = secCurPercntVal - item.secModelTargetPercnt;
        const secAbsVarianceAfterAdj = secPercntValAfterAdj - item.secModelTargetPercnt;
        const secRelVariance = (secAbsVariance * 100) / item.secModelTargetPercnt;
        const secRelVarianceAfterAdj = (secAbsVarianceAfterAdj * 100) / item.secModelTargetPercnt;
        
        item.secMktVal = secMktValChild;
        item.secCurPercntVal = secCurPercntVal;
        item.secAdjAmt = secAdjAmt;
        item.secMktValAfterAdj = secMktValAfterAdj;
        item.secPercntValAfterAdj = secPercntValAfterAdj;
        item.secAbsVariance = secAbsVariance;
        item.secRelVariance = secRelVariance;
        item.secAbsVarianceAfterAdj = secAbsVarianceAfterAdj;
        item.secRelVarianceAfterAdj = secRelVarianceAfterAdj;
    }

    getFilteredItems(data: IPortfolioResultResponse): Array<IPortfolioResultPFSECRebal> {
        let items = [].concat(data.pfSecRebalDTOList);

        if (this.showEquivalents) {
            items = items.filter((x: IPortfolioResultPFSECRebal) => !x.isEquivalentChild && !x.isEquivalent);
        } else {
            items = items.filter((x: IPortfolioResultPFSECRebal) => !x.isEquivalentChild);
        }

        if (!this.showExcluded) {
            items = items.filter((x: IPortfolioResultPFSECRebal) => (x.secExclusionType ? false : true));
        }

        items = items.filter((x: IPortfolioResultPFSECRebal) => (x.secType == "UI_GROUP" ? false : true));
        return items;
    }

    getFilteredItemsForChart(data: IPortfolioResultResponse, groupEquivalents: boolean): Array<IPortfolioResultPFSECRebal> {
        let items = [].concat(data.pfSecRebalDTOList);

        if (groupEquivalents) {
            items.forEach((x: IPortfolioResultPFSECRebal) => {
                if(x.isEquivalentParent) {
                    let eqSecIds = x.childEqvList.map((eqSec: IPortfolioResultSecurityEquivalent) => eqSec.eqvSecId);
                    let eqChildren = items.filter((c: IPortfolioResultPFSECRebal) => eqSecIds.includes(c.secId) && c.isEquivalentChild);
                    x.eqChildren = [this.util.clone(x)].concat(eqChildren);
                    
                    eqChildren.forEach((eqChild: IPortfolioResultPFSECRebal) => {
                        x.secCurPercntVal += eqChild.secCurPercntVal;
                        x.secPercntValAfterAdj += eqChild.secPercntValAfterAdj;
                    });
                }
            });

            items = items.filter((x: IPortfolioResultPFSECRebal) => !x.isEquivalentChild && !x.isEquivalent);
        } else {
            items = items.filter((x: IPortfolioResultPFSECRebal) => !x.isEquivalentChild);
        }
        
            items = items.filter((x: IPortfolioResultPFSECRebal) => (x.secExclusionType ? false : true));
            items = items.filter((x: IPortfolioResultPFSECRebal) => (x.secType == "UI_GROUP" ? false : true));
        return items;
    }

    updateSecInAllocation(data: IPortfolioResultResponse, secId: number, adjAmt: number) {
        data.pfSecRebalDTOList.forEach((item: IPortfolioResultPFSECRebal) => {
            if (item.secId === secId || (secId === null && item.secSymb === "$CASH")) {
                item.secAdjAmt = this.prutil.getFloat(adjAmt, 5);

                const secMktValAfterAdj = item.secMktVal + adjAmt;
                item.secMktValAfterAdj = this.prutil.getFloat(secMktValAfterAdj, 5);

                const isExcluded = item.secExclusionType !== null && item.secExclusionType !== undefined && (item.secExclusionType === "OPTION" || item.secExclusionType === "EXCLUDED" || item.secExclusionType === "SHORT");

                let secPercntValAfterAdj: number;

                if (data.mktValAfterAdj !== 0) {
                    secPercntValAfterAdj = (secMktValAfterAdj / data.mktValAfterAdj) * 100; //IREBALOPNS-1024
                } else {
                    secPercntValAfterAdj = 0;
                }

                if (!isExcluded) {
                    item.secPercntValAfterAdj = this.prutil.getFloat(secPercntValAfterAdj, 5);

                    const secAbsVarianceAfterAdj = secPercntValAfterAdj - item.secModelTargetPercnt;
                    item.secAbsVarianceAfterAdj = this.prutil.getFloat(secAbsVarianceAfterAdj, 5);

                    if (item.secModelTargetPercnt > 0) {
                        const secRelVarianceAfterAdj = (secAbsVarianceAfterAdj * 100) / item.secModelTargetPercnt;
                        item.secRelVarianceAfterAdj = this.prutil.getFloat(secRelVarianceAfterAdj, 5);
                    } else {
                        item.secRelVarianceAfterAdj = 100;
                    }
                } else {
                    item.secPercntValAfterAdj = 0;
                    item.secRelVarianceAfterAdj = 100;
                }

                let targetAllocInDollars = 0;

                if (item.secModelTargetPercnt > 0) {
                    targetAllocInDollars = (item.secModelTargetPercnt / 100) * data.mktValAfterAdj;
                }

                item.secDolrVariance = item.secMktVal - targetAllocInDollars;
                item.secDolrVarianceAfterAdj = secMktValAfterAdj - targetAllocInDollars;
            }
        });
    }

    updateAfterAdjValues(data: IPortfolioResultResponse) {
        let adjustVal = 0;
        let secPercntValAfterAdj;

        data.pfSecRebalDTOList.forEach((item: IPortfolioResultPFSECRebal) => {
            const isExcluded = item.secExclusionType != null && item.secExclusionType !== undefined && (item.secExclusionType === "OPTION" || item.secExclusionType === "EXCLUDED" || item.secExclusionType === "SHORT");

            if (!isExcluded && !item.isEquivalentChild) {
                adjustVal += item.secMktValAfterAdj;
            }
        });

        data.mktValAfterAdj = adjustVal;

        data.pfSecRebalDTOList.forEach((item: IPortfolioResultPFSECRebal) => {
            const isExcluded = item.secExclusionType && (item.secExclusionType === "OPTION" || item.secExclusionType === "EXCLUDED" || item.secExclusionType === "SHORT");

            if (!isExcluded) {
                const v = item.secMktValAfterAdj;
                const secModelTargetPercnt = item.secModelTargetPercnt;

                if (adjustVal !== 0) {
                    secPercntValAfterAdj = (v / adjustVal) * 100;
                } else {
                    secPercntValAfterAdj = 0;
                }

                item.secPercntValAfterAdj = this.prutil.roundDecNumber(secPercntValAfterAdj, 5);
                const secAbsVarianceAfterAdj = secPercntValAfterAdj - secModelTargetPercnt;
                item.secAbsVarianceAfterAdj = this.prutil.roundDecNumber(secAbsVarianceAfterAdj, 5);

                if (secModelTargetPercnt > 0) {
                    const secRelVarianceAfterAdj = (secAbsVarianceAfterAdj * 100) / secModelTargetPercnt;
                    item.secRelVarianceAfterAdj = this.prutil.roundDecNumber(secRelVarianceAfterAdj, 5);
                } else {
                    item.secRelVarianceAfterAdj = 100;
                }
            } else {
                item.secPercntValAfterAdj = 0;
                item.secRelVarianceAfterAdj = 100;
            }
        });

        if (data.accRebalDTOList) {
            data.accRebalDTOList.forEach((r: IPortfolioResultACCRebal) => {
                const maxVal = r.cashMax;//r.useModelCash ? r.cashMax : r.cashTarget;
                const availCash = this.isCashEqvEnabled ? r.availCash + r.cashEquivAvail : r.availCash;
                const afterRebalAvailAmt = this.isCashEqvEnabled ? r.afterRebalAvailAmt + r.cashEquivAfterAdj : r.afterRebalAvailAmt;
                r.isWithinRangeBefore = this.checkWithinRange(r.cashMin, maxVal, availCash);
                r.isAboveRangeBefore = r.isWithinRangeBefore ? false : availCash > maxVal;
                r.isWithinRangeAfter = this.checkWithinRange(r.cashMin, maxVal, afterRebalAvailAmt);
                r.isAboveRangeAfter = r.isWithinRangeAfter ? false : afterRebalAvailAmt > maxVal;
                r.negativeCashWarningShown = afterRebalAvailAmt < 0;
            });
        }

        if (data.pfSecRebalDTOList) {
            data.pfSecRebalDTOList.forEach((r: IPortfolioResultPFSECRebal) => {
                r.isWithinRangeBefore = this.checkWithinRange(r.secMinTolPercnt, r.secMaxTolPercnt, r.secCurPercntVal);
                r.isAboveRangeBefore = r.isWithinRangeBefore ? false : r.secCurPercntVal > r.secMaxTolPercnt;
                r.isWithinRangeAfter = this.checkWithinRange(r.secMinTolPercnt, r.secMaxTolPercnt, r.secPercntValAfterAdj);
                r.isAboveRangeAfter = r.isWithinRangeAfter ? false : r.secPercntValAfterAdj > r.secMaxTolPercnt;
            });
        }
    }

    checkWithinRange(min: number, max: number, targetVal: number) {
        if (min != null && max != null && targetVal != null && min <= max) {
            targetVal = Number(targetVal.toFixed(2));
            min = Number(min.toFixed(2));
            max = Number(max.toFixed(2));

            if (targetVal < min) {
                return min - targetVal === 0.01 ? true : false;
            } else if (targetVal >= min && targetVal <= max) {
                return true;
            } else if (targetVal > max) {
                return targetVal - max === 0.01 ? true : false;
            }
        } else {
            return null;
        }
    }

    appendEquivalents(data: IPortfolioResultResponse) {
        if(this.group === 'ungroupedAllocLabel' && this.showEquivalents) {
            let c = data.pfSecRebalDTOList.filter((item: IPortfolioResultPFSECRebal) => item.isEquivalentParent);
            let i = -1;

            c.forEach((x: IPortfolioResultPFSECRebal) => {
                data.pfSecRebalDTOList.push({
                    secCatagory: 'UI_GROUP_FOR_' + x.secSymb,
                    secSymb: x.secSymb,
                    secType: 'UI_GROUP',
                    secId: i--,
                    groupSize: x.childEqvList.length + 1
                } as IPortfolioResultPFSECRebal);
            });
        }
    }

    appendStyleBoxLabels(data: IPortfolioResultResponse) {
        if(this.group === 'styleBoxLabel') {
            let c = [...new Set(data.pfSecRebalDTOList.map(item => item.styleBoxLabel))];
            c = c.filter((x: string) => x !== null);
            let i = -1;

            c.forEach((x: string) => {
                const s = this.getFilteredItems(data).filter((item: IPortfolioResultPFSECRebal) => item.styleBoxLabel == x);

                data.pfSecRebalDTOList.push({
                    styleBoxLabel: x,
                    secSymb: x,
                    secType: 'UI_GROUP',
                    secId: i--,
                    groupSize: s.length
                } as IPortfolioResultPFSECRebal);
            });            
        }
    }

    appendSecurityTypes(data: IPortfolioResultResponse) {
        if(this.group === 'sacSecurityType') {
            let c = [...new Set(data.pfSecRebalDTOList.map(item => item.sacSecurityType))];
            c = c.filter((x: string) => x !== null);
            let i = -1;

            c.forEach((x: string) => {
                const s = this.getFilteredItems(data).filter((item: IPortfolioResultPFSECRebal) => item.sacSecurityType == x);
                
                data.pfSecRebalDTOList.push({
                    sacSecurityType: x,
                    secSymb: x,
                    secType: 'UI_GROUP',
                    secId: i--,
                    groupSize: s.length
                } as IPortfolioResultPFSECRebal);
            });            
        }
    }

    appendSecCategories(data: IPortfolioResultResponse) {
        if(this.group === 'SecCustCatAllocLabel') {
            let c = [...new Set(data.pfSecRebalDTOList.map(item => item.secCatagory))];
            let i = -1;

            c.forEach((x: string) => {
                const s = this.getFilteredItems(data).filter((item: IPortfolioResultPFSECRebal) => item.secCatagory == x);
                
                data.pfSecRebalDTOList.push({
                    secCatagory: x,
                    secSymb: x,
                    secType: 'UI_GROUP',
                    secId: i--,
                    groupSize: s.length
                } as IPortfolioResultPFSECRebal);
            });            
        }
    }

    appendACLevels(data: IPortfolioResultResponse) {   
        let i = -1;
        
        if(this.group === 'ACLevel') { 
            i = this.refactorAssetsWithMultipleACLevels(data, i);        
            
            this.getFilteredItems(data).forEach((item: IPortfolioResultPFSECRebal) => {
                item.path = [];

                if(this.assetClassDetail4) {
                    //get associated level 4s
                    let acLevel4 = {} as any;

                    item.acLevel4?.forEach((acLevel: IACLevel) => {
                        acLevel4[acLevel.code] = acLevel.label;
                        item.path.unshift(acLevel.code.toString());

                        for (const code in acLevel4) {
                            let level4Code = code.toString();
                            let level3Code = level4Code.substring(0,6);
                            let level2Code = level3Code.substring(0,4);
                            let level1Code = level2Code.substring(0,2);
                            let path: Array<string> = [];

                            if(this.assetClassDetail3) {
                                path.unshift(level3Code);
                            } 
                            
                            if(this.assetClassDetail2) {
                                path.unshift(level2Code);
                            } 
                            
                            if(this.assetClassDetail1) {
                                path.unshift(level1Code);
                            }

                            this.insertUIGroup(data, acLevel4, level4Code, i--, path);
                        }   
                    });    
                }
                
                if(this.assetClassDetail3) {
                    //get associated level 3s
                    let acLevel3 = {} as any;                    
                    
                    item.acLevel3?.forEach((acLevel: IACLevel) => {                        
                        acLevel3[acLevel.code] = acLevel.label;
                        item.path.unshift(acLevel.code.toString());        

                        for (const code in acLevel3) {
                            let level3Code = code.toString();
                            let level2Code = level3Code.substring(0,4);
                            let level1Code = level2Code.substring(0,2);
                            let path: Array<string> = [];

                            if(this.assetClassDetail2) {
                                path.unshift(level2Code);
                            } 
                            
                            if(this.assetClassDetail1) {
                                path.unshift(level1Code);
                            }

                            this.insertUIGroup(data, acLevel3, level3Code, i--, path);
                        }                        
                    });
                }

                if(this.assetClassDetail2) {
                    //get associated level 2s
                    let acLevel2 = {} as any;                    
                    
                    item.acLevel2?.forEach((acLevel: IACLevel) => {                        
                        acLevel2[acLevel.code] = acLevel.label;
                        item.path.unshift(acLevel.code.toString());   

                        for (const code in acLevel2) {
                            let level2Code = code.toString();
                            let level1Code = level2Code.substring(0,2);
                            let path: Array<string> = [];
                            
                            if(this.assetClassDetail1) {
                                path.unshift(level1Code);
                            }

                            this.insertUIGroup(data, acLevel2, level2Code, i--, path);
                        }                        
                    });
                }

                if(this.assetClassDetail1) {
                    //get associated level 1s
                    let acLevel1 = {} as any;                    
                    
                    item.acLevel1?.forEach((acLevel: IACLevel) => {                        
                        acLevel1[acLevel.code] = acLevel.label;
                        item.path.unshift(acLevel.code.toString());  

                        for (const code in acLevel1) {
                            let level1Code = code.toString();
                            let path: Array<string> = [];
                            this.insertUIGroup(data, acLevel1, level1Code, i--, path);
                        }                        
                    });
                }
            });
        }
    }

    insertUIGroup(data: IPortfolioResultResponse, acLevel: any, levelCode: string, secId: number, path: Array<string>) {
        let r = data.pfSecRebalDTOList.filter((item: IPortfolioResultPFSECRebal) => item.secCatagory == levelCode);

        if(r.length == 0) {
            path.push(levelCode);
            data.pfSecRebalDTOList.push({
                secCatagory: levelCode,
                secSymb: acLevel[levelCode],
                secType: 'UI_GROUP',
                secId: secId,
                path: path,
                groupSize: 1
            } as IPortfolioResultPFSECRebal);
        } else {
            r[0].groupSize++;
        }
    }

    refactorAssetsWithMultipleACLevels(data: IPortfolioResultResponse, secId: number) {
        for(let i = 0; i < data.pfSecRebalDTOList.length; i++) {
            let item = data.pfSecRebalDTOList[i];

            if(this.assetClassDetail4 && item.acLevel4?.length > 1) {
                while(item.acLevel4.length > 0) {
                    let c = this.util.clone(item);
                    let acLevel = item.acLevel4.pop();
                    c.acLevel1 = item.acLevel1.filter(x => x.code.toString() === acLevel.code.toString().substring(0,2));
                    c.acLevel2 = item.acLevel2.filter(x => x.code.toString() === acLevel.code.toString().substring(0,4));
                    c.acLevel3 = item.acLevel3.filter(x => x.code.toString() === acLevel.code.toString().substring(0,6));
                    c.acLevel4 = [acLevel];
                    c.secId = secId--;
                    this.applyACLevelAllocation(c, c.acLevel4[0].allocation);
                    data.pfSecRebalDTOList.push(c);
                }

                if(item.acLevel4.length === 0) {
                    const index = data.pfSecRebalDTOList.indexOf(item);

                    if (index > -1) {
                        data.pfSecRebalDTOList.splice(index, 1); i--;
                    }
                }
            } else if(this.assetClassDetail3 && item.acLevel3?.length > 1) {      
                while(item.acLevel3.length > 0) {
                    let c = this.util.clone(item);
                    let acLevel = item.acLevel3.pop();
                    c.acLevel1 = item.acLevel1.filter(x => x.code.toString() === acLevel.code.toString().substring(0,2));
                    c.acLevel2 = item.acLevel2.filter(x => x.code.toString() === acLevel.code.toString().substring(0,4));
                    c.acLevel3 = [acLevel];
                    c.acLevel4 = [];
                    c.secId = secId--;
                    this.applyACLevelAllocation(c, c.acLevel3[0].allocation);
                    data.pfSecRebalDTOList.push(c);
                }

                if(item.acLevel3.length === 0) {
                    const index = data.pfSecRebalDTOList.indexOf(item);

                    if (index > -1) {
                        data.pfSecRebalDTOList.splice(index, 1); i--;
                    }
                }
            } else if(this.assetClassDetail2 && item.acLevel2?.length > 1) {           
                while(item.acLevel2.length > 0) {
                    let c = this.util.clone(item);
                    let acLevel = item.acLevel2.pop();
                    c.acLevel1 = item.acLevel1.filter(x => x.code.toString() === acLevel.code.toString().substring(0,2));
                    c.acLevel2 = [acLevel];
                    c.acLevel3 = [];
                    c.acLevel4 = [];
                    c.secId = secId--;
                    this.applyACLevelAllocation(c, c.acLevel2[0].allocation);
                    data.pfSecRebalDTOList.push(c);
                }

                if(item.acLevel2.length === 0) {
                    const index = data.pfSecRebalDTOList.indexOf(item);

                    if (index > -1) {
                        data.pfSecRebalDTOList.splice(index, 1); i--;
                    }
                }
            } else if(this.assetClassDetail1 && item.acLevel1?.length > 1) {            
                while(item.acLevel1.length > 0) {
                    let c = this.util.clone(item);
                    c.acLevel1 = [item.acLevel1.pop()];
                    c.acLevel2 = [];
                    c.acLevel3 = [];
                    c.acLevel4 = [];
                    c.secId = secId--;
                    this.applyACLevelAllocation(c, c.acLevel1[0].allocation);
                    data.pfSecRebalDTOList.push(c);
                }

                if(item.acLevel1.length === 0) {
                    const index = data.pfSecRebalDTOList.indexOf(item);

                    if (index > -1) {
                        data.pfSecRebalDTOList.splice(index, 1); i--;
                    }
                }
            }
        }

        return secId;
    }

    applyACLevelAllocation(item: IPortfolioResultPFSECRebal, alloc: number) {
        let p = alloc / 100;
        item.secModelTargetDollar *= p;
        item.secModelTargetPercnt *= p;
        item.secMktVal *= p;
        item.secCurPercntVal *= p;
        item.secDolrVariance *= p;
        item.secAbsVariance *= p;
        item.secRelVariance *= p;
        item.secAdjAmt *= p;
        item.secMktValAfterAdj *= p;
        item.secDolrVarianceAfterAdj *= p;
        item.secPercntValAfterAdj *= p;
        item.secAbsVarianceAfterAdj *= p;
        item.secRelVarianceAfterAdj *= p;
        item.isACLevelMulti = true;
    }

    getDefaultPDFExportConfig(data: IPortfolioResultResponse, allcnGroupIndex: number) {
        return {
            showSummaryReport: true,
            showCashReport: true,
            showOrderReport: true,
            showAllOrder: false,
            showAllcnReport: true,
            showAllcnDollarPercent: false,
            allcnGroup: this.getAllocGroup(allcnGroupIndex),
            allcnGroupCCName: data.envGlobalSettingsDTO?.securityCustAttrAbbr,
            allcnSortModel: [{sort: "secSymb", order: "asc"}],
            orderSortModel: [{sort: "accountNum", order: "asc"}],
            cashSortModel: [{sort: "accountNum", order: "asc"}],
            showAllcnAbsVar: false,
            showAllcnExcludedPositions: this.showExcluded,
            showAllcnGroupEquivalents: this.showEquivalents,
            showAllcnChartReport: true,
            chartGroupCCName: data.envGlobalSettingsDTO?.securityCustAttrAbbr,
            assetClassDetail1: this.assetClassDetail1,
            assetClassDetail2: this.assetClassDetail2,
            assetClassDetail3: this.assetClassDetail3,
            assetClassDetail4: this.assetClassDetail4,
            allcnChartConfig: {
                showPositions: true,
                showEquivalents: true,
                showSAC: true,
                showSACLevel1: true,
                showSACLevel2: false,
                showSACLevel3: false,
                showSACLevel4: false,
                showCustCat: true,
                showMorningstarStockStyles: true,
                showSACSecurityType: true,
                chartStyle: "BAR_CHART",
                sortMap: {
                    "POSITION": {column: "label", order: "asc"},
                    "SEC_CATEGORY": {column: "label", order: "asc"},
                    "STYLE_BOX": {column: "label", order: "asc"},
                    "SEC_TYPE": {column: "label", order: "asc"},
                    "SAC1": {column: "label", order: "asc"},
                    "SAC2": {column: "label", order: "asc"},
                    "SAC3": {column: "label", order: "asc"},
                    "SAC4": {column: "label", order: "asc"}
                }
            }
        } as JasperSettings;
    }

    getAllocGroup(index: number) {
        switch(index) {
            case 0:
                return "POSITION";
            case 1:
                return "SAC";
            case 2:
                return "SEC_CATEGORY";
            case 3:
                return "STYLE_BOX";
            case 4:
                return "SEC_TYPE";
        }
    }
}
